{
    "Accessibility menu": "Menu d'accessibilité",
    "Close": "Fermer",
    "Content adjustments": "Ajustements du Contenu",
    "Navigation adjustments": "Ajustements de Navigation",
    "Text Align": "Alignement du texte",
    "Align Left": "Aligner à gauche",
    "Align Center": "Centrer",
    "Align Right": "Aligner à droite",
    "Adjust Font Size": "Ajuster la Taille de Police",
    "Highlight Title": "Mettre en Évidence le Titre",
    "Highlight Links": "Mettre en Évidence les Liens",
    "Readable Font": "Police Lisible",
    "Colour adjustments": "Ajustements de Couleur",
    "Dark Contrast": "Contraste Sombre",
    "Light Contrast": "Contraste Clair",
    "High Contrast": "Contraste Élevé",
    "High Saturation": "Saturation Élevée",
    "Low Saturation": "Saturation Faible",
    "Monochrome": "Monochrome",
    "Tools": "Outils",
    "Reading Guide": "Guide de Lecture",
    "Big Cursor": "Curseur Agrandi",
    "Increase Font Size": "Augmenter la Taille de Police",
    "Decrease Font Size": "Diminuer la Taille de Police",
    "Letter Spacing": "Espacement des Lettres",
    "Line Height": "Hauteur de Ligne",
    "Font Weight": "Épaisseur de Police",
    "Dyslexia Font": "Police pour Dyslexie",
    "Language": "Langue",
    "Accessibility widget": "Ouvrir le menu d'accessibilité",
    "Accessibility Profiles": "Profils d'Accessibilité",
    "Cognitive Disability": "Handicap Cognitif",
    "Seizure Safe": "Sûr pour l'épilepsie",
    "Accessibility statement": "Déclaration d'Accessibilité",
    "ADHD": "TDAH",
    "Low Vision": "Basse vision",
    "Pause Animations": "Arrêter les Animations",
    "Animation paused": "Animation en pause",
    "Reset all settings": "Réinitialiser les Paramètres",
    "Shortcut:": "Raccourci :",
    "Epilepsy Safe Mode": "Mode sans épilepsie",
    "Mute sounds": "Couper les sons",
    "Page read": "Lecture de la page",
    "Page read controls": "Commandes de lecture",
    "Pause": "Pause",
    "Resume": "Reprendre",
    "Stop": "Arrêter",
    "Settings": "Paramètres",
    "Speed": "Vitesse",
    "Voice": "Voix",
    "Close accessibility menu": "Fermer le menu d'accessibilité",
    "Back to accessibility menu": "Retour au menu d'accessibilité",
    "Search languages": "Rechercher une langue",
    "Selected language": "Langue sélectionnée",
    "View accessibility statement (opens in new window)": "Voir la déclaration d'accessibilité (ouvre une nouvelle fenêtre)",
    "Visit CookieYes website (opens in new window)": "Visiter le site CookieYes (ouvre une nouvelle fenêtre)",
    "Reset all accessibility settings to default": "Réinitialiser tous les paramètres d'accessibilité"
}
